import { render, staticRenderFns } from "./CardForm.vue?vue&type=template&id=3cb1ba9c&scoped=true&"
import script from "./CardForm.vue?vue&type=script&lang=ts&"
export * from "./CardForm.vue?vue&type=script&lang=ts&"
import style0 from "./CardForm.vue?vue&type=style&index=0&id=3cb1ba9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb1ba9c",
  null
  
)

export default component.exports